'use client';

import { HStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { Badge } from '../../../../../components/badge';
import { Text } from '../../../../../components/text';
import { WebSocketExecutionShell } from './WebSocketExecutionShell';
import type { WebSocketStopView } from './parse-websocket-execution-view';

type WebSocketStoppedViewProps = {
  view: WebSocketStopView;
};

export function WebSocketStoppedView({ view }: WebSocketStoppedViewProps) {
  const t = useTranslations('designSystem.chat.websocketClient');
  const tChat = useTranslations('designSystem.chat');
  const isFailed = view.outcome === 'failed';
  const statusLabel = (() => {
    switch (view.outcome) {
      case 'failed':
        return tChat('failed');
      case 'stop_requested':
        return t('stopRequested');
      case 'already_stopped':
        return t('alreadyStopped');
      case 'stopped':
        return t('connectionStopped');
      default: {
        const unhandled: never = view.outcome;

        return unhandled;
      }
    }
  })();

  return (
    <WebSocketExecutionShell
      mode="stop"
      testId="websocket-execution-stop"
      error={view.error}
      status={
        <Badge size="sm" variant="fill">
          {statusLabel}
        </Badge>
      }
    >
      <Text fontSize="xs" color={isFailed ? 'fg.error' : 'fg.muted'}>
        {statusLabel}
      </Text>
      {view.sessionId ? (
        <HStack gap={1}>
          <Text fontSize="xs" color="fg.muted" flexShrink={0}>
            {t('sessionId')}
          </Text>
          <Text
            fontSize="xs"
            fontFamily="mono"
            color="fg.subtle"
            wordBreak="break-all"
          >
            {view.sessionId}
          </Text>
        </HStack>
      ) : null}
    </WebSocketExecutionShell>
  );
}
